const o=console;export{o as defaultLogger};
